/**
 * 商城购物车缓存
 */
import { restaurantConfig, restaurantCenter, RESTAURANT_EVENT, shopcartMobx } from '@mobx/mall'
import { localStore } from '@dt/fe-utils'

/** 向storage填入商城购物车数据 */
export const setCart = () => {
  const brandId = restaurantConfig.brandId
  if (brandId) {
    const cartInfo = localStore.get('shopcart.cache.mall') || {}
    cartInfo[brandId] = shopcartMobx.getCopy(false)
    localStore.set('shopcart.cache.mall', cartInfo)
  }
}

/** 从storage获取当前品牌商城购物车数据 */
export const getCart = () => {
  const brandId = restaurantConfig.brandId
  const curCart = localStore.get('shopcart.cache.mall') && localStore.get('shopcart.cache.mall')[brandId.toString()]
  return curCart || ''
}

restaurantCenter.on(RESTAURANT_EVENT.SHOPCART_ITEMS_CHANGED, ({ type }: any) => {
  setCart()
})
